/**
 * Used to set a type with our dataTransfer so we can discern what business object is being dragged between windows
 */
import {React} from '@api'
import {BuilderCardStore, CatalogItemDetailsStore} from '@modules'
import {CatalogDataItemUIStore} from '@modules/catalog/sidebar/CatalogItemsList'
import {CatalogItemDragItemExtra} from '@stores/catalog'

export const DD_CENTRIC_TYPE_PREFIX = 'centric/'

export type DropTargetType = 'vlp-style' | 'vlp-merch-product-version' | 'GroupHeader' | 'Catalog_CreateItems' | 'CatalogItem_Carousel' | string

export interface IDragDropElement {
  ignoreEvents?: () => boolean

  /**
   * The type of item being dragged or the drop target
   * Generally something like Group,
   */
  target?: DropTargetType

  /**
   * Extra useful information for a drop target
   */
  targetExtra?: CatalogItemDragItemExtra | {data: any} | {detailsStore: CatalogItemDetailsStore} | any

  /**
   * When dragging multiple builder cards
   */
  cardStores?: Array<BuilderCardStore | CatalogDataItemUIStore>

  /**
   * If we're dragging an object, what is a unique reference for it?
   */
  id?: string | 'EXTERNAL'

  /**
   * For the group header / group contents the ID is the same but the target element is different so we need to differentiate to avoid clearing dragOverItem when moving between header and contents
   */
  extraId?: Boolean

  parentId?: string | 'EXTERNAL'

  /**
   * For secondaries a drag item will have an extra piece of information to identify the other field matches
   */
  where?: any

  /**
   * When dragging a catalog item it might be a style, a tag, an MPV, a library index, etc
   */
  dragType?: 'images' | 'plain-text' | 'assortmentCard' | 'assortmentHeroCard' | string

  /** When dragging multiple items due to selection */
  extraIds?: string[]

  /** Total number of items being dragged **/
  count?: number

  /** An optional label to use when prompting the user */
  label?: string

  /**
   *
   */
  meta?: 'assignLibrary' | 'assignField' | string

  /**
   * For drag and drop of builder card (with image) to user's desktop
   */
  imageUrl?: string

  imageDataUrl?: string
  filename?: string
  imageWidth?: number
  imageHeight?: number
  exId?: string
  section?: string

  onDragStart?: (e?: React.DragEvent) => void
}

export interface IDragDropElementState {
  type?: 'image' | 'spec' | string
  status?: 'loading' | 'success' | 'failed'
}

export interface IDropElement {
  type: string
  id?: string
  path?
}

export type DragDropInteractions = { [source: string]: { [target: string]: DragDropInteraction } }

export type DragDropInteraction = {
  onDrop?: (dragItem: IDragDropElement, dropItem: IDragDropElement, dropInteraction: Partial<DragDropInteraction>, dataTransfer?: DataTransfer) => Promise<any>

  /**
   * When dragging a style on to an MPV we want to create a clientside MPV and copy the style in - we need to know what field to assign to
   */
  field?: string

  // Copy style's name into MPV name for example
  titleField?: string

  // Can multiple items be dragged/dropped for this interaction?
  multiple?: boolean

  operation?: 'create' | 'assign'

  /**
   * For some drag overs we need to do extra logic to verify whether or not to allow drop
   * For example dragging an MPV to a group header that the MPV already is in shouldn't trigger drag/drop
   *
   */
  verify?: VerifyDragDropCallback
}

export type VerifyDragDropCallbackResult = { allowed?: boolean, message?: string }
export type VerifyDragDropCallback = (dragItem: IDragDropElement, dragOverItem: IDragDropElement) => VerifyDragDropCallbackResult


// WEBPACK FOOTER //
// ./src/stores/dragDrop/DragDropInterfaces.ts